export const generateNextSequence = (id: string, state: any) => {
  let sequence = { ...state }

  const hasKey = id in state

  const arr: number[] = Object.values(sequence)

  const maxSequence = Math.max(...arr)

  if (!hasKey && maxSequence) sequence[id] = maxSequence + 1

  if (maxSequence < 0) sequence = { [id]: 1 }

  return { [id]: sequence[id] }
}
